import {
  Button,
  CloseButton,
  Flex,
  Heading,
  Modal,
  Spinner,
} from "@instructure/ui";
import { useTranslation } from "react-i18next";
import React from "react";

export const CommonModal = ({
  openModal,
  setOpenModal,
  handleClose,
  label,
  size,
  handleSubmit,
  body,
  inProgress,
}) => {
  const { t } = useTranslation();

  return (
    <Modal open={openModal} size={size} label={label} onExited={handleClose}>
      <Modal.Header>
        <Flex justifyItems="space-between">
          <Flex.Item>
            <Heading as="h3">{label}</Heading>
          </Flex.Item>
          <Flex.Item>
            <CloseButton
              offset="small"
              onClick={() => setOpenModal(false)}
              screenReaderLabel={t("global.close")}
            />
          </Flex.Item>
        </Flex>
      </Modal.Header>
      {body}
      <Modal.Footer>
        <Button onClick={() => setOpenModal(false)} margin="0 x-small 0 0">
          {t("global.cancel")}
        </Button>
        <Button
          onClick={handleSubmit}
          color="primary"
          type="submit"
          disabled={inProgress}
        >
          {inProgress ? (
            <Spinner renderTitle={t("global.pleaseWait")} size="x-small" />
          ) : (
            t("global.save")
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
